import EdicaoService from '../../services/EdicaoService'
import router from '../../router'

const state = () => ({
    loadingEdicao: false,
    edicao: null,
    edicoes: [],          // lista paginada (tela de Edições)
    edicoesAll: [],       // ativas, para selects
    totalDisciplinas: 0,
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_edicao: false
})

const mutations = {
    SET_EDICAO: (state, payload) => {
        state.edicao = payload
    },
    SET_EDICAO_TOTAL_DISCIPLINAS: (state, payload) => {
        state.totalDisciplinas = payload
    },
    SET_EDICOES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.edicoes = payload.itens
        }else{
            state.edicoes = [...state.edicoes, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total
    },
    SET_EDICOES_ALL: (state, payload) => {
        state.edicoesAll = payload
    },
    SET_LOADING_EDICOES: (state, payload) => {
        state.loadingEdicao = payload
    },
    SET_SHOW_MODAL_NEW_EDICAO: (state, payload) => {
        state.show_modal_new_edicao = payload
    },
}

const actions = {
    async fetchEdicao({commit}, id){
        try{
            commit('SET_LOADING_EDICOES', true)
            const response = await EdicaoService.getOne(id);
            commit('SET_EDICAO', response.data.item)
            commit('SET_EDICAO_TOTAL_DISCIPLINAS', response.data.totalDisciplinas || 0)
            commit('SET_LOADING_EDICOES', false)
        } catch (error) {
            commit('SET_LOADING_EDICOES', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchEdicoes({commit}, params = {}){
        try{
            commit('SET_LOADING_EDICOES', true)
            const { keyword = '', pageNumber = 1 } = params;
            const response = await EdicaoService.get(keyword, pageNumber);
            commit('SET_EDICOES', response.data)
            commit('SET_LOADING_EDICOES', false)
        } catch (error) {
            commit('SET_LOADING_EDICOES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchEdicoesAll({commit}){
        try{
            const response = await EdicaoService.getAll();
            commit('SET_EDICOES_ALL', response.data)
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error?.response?.data?.message || 'Falha ao carregar as Edições.'
            });
        }
    },
    async createEdicao({commit, dispatch, rootState}, data){
        try{
            commit('SET_LOADING_EDICOES', true)
            const response = await EdicaoService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            // Criada a partir do formulário de Disciplina: já seleciona a nova edição
            if(rootState.disciplina.disciplina) rootState.disciplina.disciplina.edicaoId = response.data.item.id;
            dispatch('fetchEdicoesAll')
            dispatch('fetchEdicoes', { keyword: ''})
            commit('SET_SHOW_MODAL_NEW_EDICAO', false)
            commit('SET_LOADING_EDICOES', false)
        } catch (error) {
            commit('SET_LOADING_EDICOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeEdicao({commit, dispatch}, data){
        try{
            commit('SET_LOADING_EDICOES', true)
            const response = await EdicaoService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            dispatch('fetchEdicoesAll')
            commit('SET_LOADING_EDICOES', false)
        } catch (error) {
            commit('SET_LOADING_EDICOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async vincularSemEdicao({commit, dispatch}, id){
        try{
            commit('SET_LOADING_EDICOES', true)
            const response = await EdicaoService.vincularSemEdicao(id);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            dispatch('fetchEdicao', id)
        } catch (error) {
            commit('SET_LOADING_EDICOES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getEdicao: state => state.edicao,
    getEdicaoTotalDisciplinas: state => state.totalDisciplinas,
    getEdicoes: state => state.edicoes,
    getEdicoesAll: state => state.edicoesAll,
    getLoadingEdicao: state => state.loadingEdicao,
    getShowModalNewEdicao: state => state.show_modal_new_edicao
}

export default {
    state,
    getters,
    mutations,
    actions
};
